module.exports = __webpack_public_path__ + "static/media/3_portrait.60801d3c.jpg";